module.exports = __webpack_public_path__ + "static/5-aa02fd810cff36f12bdd31e99d011db8.png";